(() => {
  if (customElements.get('mg-discount')) return;
  class MGDiscount extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.button = this.querySelector('.mg-offer__copy');
      this.code = this.querySelector('.mg-offer__code');
      this.status = this.querySelector('.mg-offer__status');
      if (!this.button || !this.code || !this.status) return;
      this.button.hidden = false;
      this.checkDates();
      this.button.addEventListener('click', () => this.copy(), { signal: this.controller.signal });
      document.addEventListener('visibilitychange', () => this.checkDates(), { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      clearTimeout(this.expiryTimer);
    }
    checkDates() {
      clearTimeout(this.expiryTimer);
      const now = Date.now();
      const start = this.dataset.start ? Date.parse(this.dataset.start) : null;
      const end = this.dataset.end ? Date.parse(this.dataset.end) : null;
      this.hidden = (start !== null && (!Number.isFinite(start) || now < start)) ||
        (end !== null && (!Number.isFinite(end) || now >= end));
      if (!this.hidden && end !== null) {
        this.expiryTimer = setTimeout(() => this.checkDates(), Math.min(end - now + 10, 2147483647));
      }
    }
    async copy() {
      this.checkDates();
      if (this.hidden) return;
      this.button.disabled = true;
      const code = this.code.textContent.trim();
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(code);
        this.status.textContent = this.dataset.copied;
      } catch {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(this.code);
        selection?.removeAllRanges();
        selection?.addRange(range);
        this.status.textContent = this.dataset.failed;
      } finally {
        this.button.disabled = false;
      }
    }
  }
  customElements.define('mg-discount', MGDiscount);
})();
